import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import SvalbardImage from '../components/svalbard.png'; // Adjust the path to your image

function Year2026() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };

    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };
  
    return (
      <div className="year-page">
         <h1>2026 Photos</h1>
         <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Svalbard Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/svalbard')} // Redirect to /svalbard
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${SvalbardImage})` }}
            ></div>
            <p className="location-name">Svalbard</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2026;